import sortBy from 'lodash/sortBy';
import axios from 'axios';

export const loadProjectList = async () => {
	await axios
		.get(
			'/jsonapi/node/deltek_data?filter[id][condition][path]=field_data_type&filter[id][condition][value]=projects'
		)
		.then(response => {
			const data = response?.data?.data?.[0] || {};
			const list = JSON.parse(data.attributes?.field_json_data ?? '[]');

			window.projectList = list.map(x => ({
				...x,
				ppnumber: `${x.project_number}-${x.phase_number}`
			}));
		});
};

export const loadClientList = async () => {
	await axios
		.get(
			'/jsonapi/node/deltek_data?filter[id][condition][path]=field_data_type&filter[id][condition][value]=clients'
		)
		.then(response => {
			const data = response?.data?.data?.[0] || {};
			window.clientList = JSON.parse(data.attributes?.field_json_data ?? '[]');
		});
};

export const loadUserDirectory = async () => {
	await axios
		.get(
			'/jsonapi/node/deltek_data?filter[id][condition][path]=field_data_type&filter[id][condition][value]=employees'
		)
		.then(response => {
			const data = response?.data?.data?.[0] || {};
			let employees = JSON.parse(data.attributes?.field_json_data ?? '[]');

			if (employees.length) {
				employees = sortBy(employees, employee => {
					const name = employee.name.split(' ');
					let lastName;

					if (name.length === 2) {
						lastName = name[1];
					} else if (name.length === 3) {
						if (name[2].match(/^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/)) {
							lastName = name[1];
						} else {
							lastName = name[2];
						}
					}

					return lastName;
				});
			}

			window.employeeList = employees;
		});
};

// Gets per diem form settings for Project Information
export const loadSettings = async () => {
	await axios.get('/jsonapi/node/app_data').then(response => {
		const data = response?.data?.data?.[0] || {};

		window.appData = {
			per_diem_settings: JSON.parse(data.attributes?.field_per_diem_settings ?? '{}'),
			per_diem_times: JSON.parse(data.attributes?.field_per_diem_times ?? '{}')
		};
	});
};
